import { Avatar, Badge, Button, Dropdown, Menu, Modal, Row, Tooltip, Icon } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { fromSummary, getHeaderSummary, onLoadHeader, onLoadPrinter } from './../../actions/headerAction';
import { onTab } from './../../actions/ordersAction';
import { onQuickSearch } from './../../actions/quickSearchAction';
import { onTab as onTabShipment, setFulfillmentOption } from './../../actions/shipmentAction';
import { orderStatus, shipmentStatus } from './../../constants';
import logo from './../../resources/assets/images/logo.png';
import operationManual from './../../resources/assets/images/operation-manual.png';
import order from './../../resources/assets/images/orderHeader.png';
import shipment from './../../resources/assets/images/shipment2.png';
import button from './../../resources/assets/images/Summary.png';
import pdfOperationManual from './../../resources/files/Y-Ship-Cloud-Operation-Manual.pdf';
import pdfRakuten from './../../resources/files/Y-Ship-Cloud-Getting-Started-Rakuten.pdf';
import pdfAmazon from './../../resources/files/Y-Ship-Cloud-Getting-Started-Amazon.pdf';
import pdfBuyMa from './../../resources/files/Y-Ship-Cloud-Getting-Started-Buyma.pdf';
import history from './../../services/history';
import Storage from './../../services/Storage';
import { logout } from './../../utils/login';
import Cookies from 'js-cookie';
import './styles.css';
import lang from './../../languages/en'
import { alertError, confirmChangeItem } from './../../services/dialog';
import handlePermission from './../../containers/app/handlePermission';
import { permissions, FulfillOption } from './../../constants';
import { logoutProcess } from './../../services/authHelper';
import { resetHeaderSumary } from './../../actions/headerAction';
import { resetSumaryOrder } from './../../actions/ordersAction';
import { resetSumaryShipment } from './../../actions/shipmentAction';
import icon_link_shipment_fulfillment from "./../../resources/assets/images/icon-link-shipment-fulfillment.png";
class Header extends Component {
    constructor(props) {
        super(props)
        this.state = {
            current: 'mail',
            selected: '',
            logoutModal: false,
            showSetting: false
        }
        this.handleMount()
    }

    handleMount = () => {
        let userStorage = Storage.get('user');
        Storage.accessToken()
        if (userStorage && !userStorage.permissions) {
            history.push('/login')
            alertError(lang.permission_denied)
            Storage.clearAll()
        }
    }

    componentDidMount = () => {
        let url = window.location.href
        let selected = url.split('/').pop()

        this.setState({
            selected,
        })
        this.props.getHeaderSummary()
        this.outFocus()
    }

    outFocus = () => {
        document.addEventListener('click', function (e) {
            if (document.activeElement) {
                if (document.activeElement.toString() == '[object HTMLButtonElement]') {
                    document.activeElement.blur();
                }
            }
        });
    }

    handleClick = e => {
        this.setState({
            current: e.key,
        })
    }

    logout = () => {
        this.setState({ logoutModal: true, })
    }

    onCancel = () => {
        this.setState({ logoutModal: false, })
    }
    onOk = () => {
        this.setState({ logoutModal: false, })
        this.props.resetHeaderSumary();
        this.props.resetSumaryOrder();
        this.props.resetSumaryShipment();
        logoutProcess();
    }

    onClick = () => {
        this.setState({
            showSetting: !this.state.showSetting
        })

        let userTooltip = document.getElementsByClassName('header-user-infor-tooltip')
        if (userTooltip.length) {
            userTooltip[0].classList.add('ant-tooltip-hidden')
        }
    }

    handleEditItemMaster = (e, url) => {
        if (this.props.checkErrorInput) {
            e.preventDefault()
            return alertError(lang.field_some_required)
        }
        if (this.props.editItemMaster) {
            e.preventDefault()
            confirmChangeItem(lang.confirm_save_item_name, async () => {
                await this.props.saveItemMaster()
                await history.push(url)
            }, () => {
                history.push(url)
            })
        }
    }

    handleEditItemMasterStatus = (e, typeStatus) => {
        if (this.props.checkErrorInput) {
            e.preventDefault()
            return alertError(lang.field_some_required)
        }
        if (this.props.editItemMaster) {
            e.preventDefault()
            confirmChangeItem(lang.confirm_save_item_name, async () => {
                await this.props.saveItemMaster()
                await this.handleStatus(e, typeStatus)
            }, () => {
                this.handleStatus(e, typeStatus)
            })
        } else {
            this.handleStatus(e, typeStatus)
        }
    }

    handleStatus = (e, typeStatus) => {
        switch (typeStatus) {
            case 'awaitingFinalization':
                this.awaitingFinalization(e)
                return;
            case 'readyToPrint':
                this.readyToPrint(e)
                return;
            case 'readyToTransmit':
                this.readyToTransmit(e)
                return;
            case 'fulfillmentInProcess':
                this.fulfillmentInProcess(e)
                return;
            case 'fulfillmentCompleted':
                this.fulfillmentCompleted(e)
                return;
            default:
                this.awaitingFinalization()
                return;
        }
    }

    awaitingFinalization = (e) => {
        e.preventDefault();
        if (history.location.pathname !== '/orders') {
            this.props.fromSummary({ fromSummary: true, tab: orderStatus.AWAITING_FINALIZATION })
            history.push('/orders')
        }
        this.props.onTab({ tab: orderStatus.AWAITING_FINALIZATION, PageSize: this.props.getOrderParams.PageSize })
    }

    readyToPrint = (e) => {
        e.preventDefault();
        if (this.props.Summary.FulfillmentFlg) {
            if (history.location.pathname !== '/shipments/in-house') {
                this.props.fromSummary({ fromSummary: true, tab: shipmentStatus.READY_TO_PRINT })
                history.push('/shipments/in-house')
            }
        } else {
            if (history.location.pathname !== '/shipments') {
                this.props.fromSummary({ fromSummary: true, tab: shipmentStatus.READY_TO_PRINT })
                history.push('/shipments')
            }
        }
        this.props.setFulfillmentOption(FulfillOption.IN_HOUSE.CODE);
        this.props.onTabShipment({ tab: shipmentStatus.READY_TO_PRINT, PageSize: this.props.getShipmentParams.PageSize })
    }
    readyToTransmit = (e) => {
        e.preventDefault();
        if (this.props.Summary.FulfillmentFlg) {
            if (history.location.pathname !== '/shipments/in-house') {
                this.props.fromSummary({ fromSummary: true, tab: shipmentStatus.READY_TO_TRANSMIT })
                history.push('/shipments/in-house')
            }
        } else {
            if (history.location.pathname !== '/shipments') {
                this.props.fromSummary({ fromSummary: true, tab: shipmentStatus.READY_TO_TRANSMIT })
                history.push('/shipments')
            }
        }
        this.props.setFulfillmentOption(FulfillOption.IN_HOUSE.CODE);
        this.props.onTabShipment({ tab: shipmentStatus.READY_TO_TRANSMIT, PageSize: this.props.getShipmentParams.PageSize })
    }

    fulfillmentInProcess = (e) => {
        e.preventDefault();
        if (history.location.pathname !== '/shipments/yamato') {
            this.props.fromSummary({ fromSummary: true, tab: shipmentStatus.FULFILLMENT_IN_PROCESS })
            history.push('/shipments/yamato')
        }
        this.props.setFulfillmentOption(FulfillOption.YAMATO.CODE);
        this.props.onTabShipment({ tab: shipmentStatus.FULFILLMENT_IN_PROCESS, PageSize: this.props.getShipmentParams.PageSize, FulfillmentOption: FulfillOption.YAMATO.CODE })
    }

    fulfillmentCompleted = (e) => {
        e.preventDefault();
        if (history.location.pathname !== '/shipments/yamato') {
            this.props.fromSummary({ fromSummary: true, tab: shipmentStatus.FULFILLMENT_COMPLETED })
            history.push('/shipments/yamato')
        }
        this.props.setFulfillmentOption(FulfillOption.YAMATO.CODE);
        this.props.onTabShipment({ tab: shipmentStatus.FULFILLMENT_COMPLETED, PageSize: this.props.getShipmentParams.PageSize, FulfillmentOption: FulfillOption.YAMATO.CODE })
    }
    onClickMenuShippment = (e) => {
        // e.preventDefault();
    }

    render() {
        const { selected } = this.state
        const user = Storage.get('user')
        const shipperActive = Storage.get('shipper_active');
        let isShowMenuNormal = true;
        if (this.props.isShowMenuNormal !== undefined) {
            isShowMenuNormal = this.props.isShowMenuNormal
        }
        let { Summary, fulfillmentCompletedCount } = this.props;
        let FulfillmentFlg = parseInt(Storage.get('FulfillmentFlg'))

        const menu = (
            <Menu
                className='menu-setting-header'
            >
                {
                    handlePermission(permissions.EcCredentialSaveSetting) && isShowMenuNormal ?
                        <Menu.Item key="0">
                            <Link onClick={(e) => this.handleEditItemMaster(e, '/setting/channel')} to="/setting/channel">E-Commerce Channels</Link>
                        </Menu.Item>
                        : ""
                }

                {
                    handlePermission(permissions.ItemNameSearchAll) && isShowMenuNormal ?
                        <Menu.Item key="1">
                            <Link onClick={(e) => this.handleEditItemMaster(e, '/setting/merchant')} to="/setting/merchant">Global Merchant Settings</Link>
                        </Menu.Item>
                        : ""
                }

                {
                    handlePermission(permissions.PrinterSavePrinterSetting) && isShowMenuNormal ?
                        <Menu.Item key="2">
                            <Link onClick={(e) => this.handleEditItemMaster(e, '/setting/printer')} to="/setting/printer">Printers</Link>
                        </Menu.Item>
                        : ""
                }

                {
                    handlePermission(permissions.UserUpdate) && isShowMenuNormal ?
                        <Menu.Item key="3">
                            <Link onClick={(e) => this.handleEditItemMaster(e, '/setting/account')} to="/setting/account">My Account</Link>
                        </Menu.Item>
                        : ""
                }

                {
                    handlePermission(permissions.SwitchShipper) && (shipperActive && shipperActive.count_shipper > 1) ?
                        <Menu.Item key="4">
                            <Link onClick={(e) => this.handleEditItemMaster(e, '/switch-shipper')} to="/switch-shipper">Switch Shipping Company</Link>
                        </Menu.Item>
                        : ''
                }

                {
                    handlePermission(permissions.MFASetUp) && isShowMenuNormal ?
                        <Menu.Item key="5">
                            <Link onClick={(e) => this.handleEditItemMaster(e, '/setting/mfa')} to="/setting/mfa">Two-Factor Authenticator</Link>
                        </Menu.Item>
                        : ''
                }
                <Menu.Item key="5">
                    <a onClick={this.logout}>Log Out</a>
                </Menu.Item>
            </Menu>
        );

        const menu_manual = (
            <Menu className="menu-dropdow-operation-manual">
                <Menu.Item key="itemOperationManual" className='item-dropdow-operation-manual'>
                    <a href={pdfOperationManual} target='_blank'>
                        Y-Ship Cloud Operation Manual
                    </a>
                </Menu.Item>

                <Menu.Item key="itemAmazonManual" className='item-dropdow-operation-manual'>
                    <a href={pdfAmazon} target='_blank'>
                        Getting Started - Amazon
                    </a>
                </Menu.Item>
                <Menu.Item key="itemRakutenManual" className='item-dropdow-operation-manual'>
                    <a href={pdfRakuten} target='_blank'>
                        Getting Started - Rakuten
                    </a>
                </Menu.Item>

                <Menu.Item key="itemRakutenManual" className='item-dropdow-operation-manual'>
                    <a href={'https://docs.google.com/presentation/d/1ATj4uezd5u1BRYrFE_Iwb5sd6_CZ9Nw7t7fRtlyX-18/edit?usp=sharing'} target='_blank'>
                        Getting Started - Buyma
                    </a>
                </Menu.Item>

                <Menu.Item key="itemDangerous" className='item-dropdow-operation-manual'>
                    <a href="https://www.yamatoamerica.com/cs/en/prohibited-items-list/" target='_blank'>
                        Dangerous and Prohibited Items
                    </a>
                </Menu.Item>
            </Menu>
        )

        const menuShippment = (
            <Menu className="menu-dropdown-shipment">
                <Menu.Item key="1">
                    <Link onClick={e => this.handleEditItemMaster(e, '/shipments/' + FulfillOption.YAMATO.TYPE_LINK)} className='block-link-when-not-save-item' to={{
                        pathname: '/shipments/' + FulfillOption.YAMATO.TYPE_LINK,
                    }}>Fulfillment by Yamato</Link>
                </Menu.Item>

                <Menu.Item key="2">
                    <Link onClick={e => this.handleEditItemMaster(e, '/shipments/' + FulfillOption.IN_HOUSE.TYPE_LINK)} className='block-link-when-not-save-item' to={{
                        pathname: '/shipments/' + FulfillOption.IN_HOUSE.TYPE_LINK,
                    }}>In-House</Link>
                </Menu.Item>
            </Menu>
        )

        const textTooltipUser = (
            <ul>
                <li>{user ? user.company : null}</li>
                <li>{shipperActive
                    && shipperActive.BranchShortNameCH
                    && shipperActive.ShipperNameCH ? shipperActive.BranchShortNameCH + ' ' + shipperActive.ShipperNameCH : null}</li>
                <li>{user ? (user.first_name + ' ' + user.last_name) : null}</li>
                <li>{user ? user.user_name : null}</li>
            </ul>
        )
        return (
            <div id="header">
                <div id="wrapfabtest">
                    <div className="adBanner">
                    </div>
                </div>
                <Modal
                    visible={this.state.logoutModal}
                    closable={false}
                    footer={[
                        <Button key={Date.now()} onClick={this.onCancel}>
                            Cancel
                        </Button>,
                        <Button key={Date.now() + 1} type="primary" onClick={this.onOk}>
                            OK
                    </Button>,
                    ]}
                >
                    Are you sure you want to logout?
                </Modal>
                <Row className="menu-header">
                    <Menu
                        className="header-left"
                        className={this.props.currentShipper === 'NULL' ? 'header-current-shipper-not-select header-left' : 'header-left'}
                        onClick={this.handleClick}
                        selectedKeys={[this.state.current]}
                        mode="horizontal"
                    >
                        <Menu.Item key="logo" className="logo logo-not-home item icon-header">
                            <div className="img">
                                <img src={logo} />
                            </div>
                        </Menu.Item>

                        <Menu.Item
                            key="orders"
                            className={`cates item icon-header orders ` + (selected === 'orders' ? 'active' : 'not-active')}
                        >
                            <Link onClick={e => this.handleEditItemMaster(e, '/orders')} className='block-link-when-not-save-item' to={{
                                pathname: '/orders', state: {
                                    from: history.location.pathname
                                }
                            }}>
                                <img src={order} />
                                <h4>Orders</h4>
                            </Link>
                        </Menu.Item>
                        {
                            FulfillmentFlg ?
                                <Dropdown
                                    trigger={['hover']}
                                    overlay={menuShippment}
                                    key="shipments"
                                    className={`shipments-fullfillment ` + (selected === 'shipments' || selected === FulfillOption.IN_HOUSE.TYPE_LINK || selected === FulfillOption.YAMATO.TYPE_LINK ? 'active' : 'not-active')}
                                >
                                    <Link className="ant-dropdown-link" onClick={e => this.handleEditItemMaster(e, '/shipments/' + FulfillOption.YAMATO.TYPE_LINK)} to={{
                                        pathname: '/shipments/' + FulfillOption.YAMATO.TYPE_LINK,
                                    }}>
                                        <img src={icon_link_shipment_fulfillment} />
                                        <Icon type="caret-down" />
                                        <span>Shipments</span>
                                    </Link>
                                </Dropdown>

                                :

                                <Menu.Item
                                    key="shipments"
                                    className={`cates item icon-header shipments ` + (selected === 'shipments' ? 'active' : 'not-active')}
                                >
                                    <Link onClick={e => this.handleEditItemMaster(e, '/shipments')} className='block-link-when-not-save-item' to={{
                                        pathname: '/shipments', state: {
                                            from: history.location.pathname
                                        }
                                    }}>
                                        <img src={shipment} />
                                        <h4>Shipments</h4>
                                    </Link>
                                </Menu.Item>
                        }
                        {
                            FulfillmentFlg ?
                                <Menu.Item key="header-status" className="cates item icon-header header-status header-status-fullfillment">
                                    <div className="header-your-orders">
                                        <div className="box-sumany-order">
                                            <div className="label-sumany">
                                                <img src={button} height="10px" width="40px" />
                                                <span>Summary</span>
                                            </div>
                                            <div className="content-sumany-order">
                                                <div className="content-head">
                                                    <span>Orders</span>
                                                </div>
                                                <div className="content-bottom">
                                                    <Badge count="Errors"
                                                        style={{ backgroundColor: '#c55a11' }}
                                                        onClick={(e) => this.handleEditItemMasterStatus(e, 'awaitingFinalization')} />
                                                    <div className="number"
                                                        onClick={(e) => this.handleEditItemMasterStatus(e, 'awaitingFinalization')} >{this.props.awaitingFinalizationTotal ? this.props.awaitingFinalizationTotal : 0}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="box-yamato-inhouse">

                                            <div className="content-yamato">
                                                <div className="content-head">
                                                    <span>Fulfillment by Yamato</span>
                                                </div>
                                                <div className="content-bottom">
                                                    <div className="content-bottom-left">
                                                        <Badge count="In Process"
                                                            style={{ backgroundColor: '#3a806e' }}
                                                            onClick={(e) => this.handleEditItemMasterStatus(e, 'fulfillmentInProcess')}
                                                        />
                                                        <div className="number"
                                                            onClick={(e) => this.handleEditItemMasterStatus(e, 'fulfillmentInProcess')}>{Summary.InProcess ? Summary.InProcess : 0}</div>
                                                    </div>

                                                    <div className="content-bottom-right">
                                                        <Badge count="To Transmit"
                                                            style={{ backgroundColor: '#00b0f0' }}
                                                            onClick={(e) => this.handleEditItemMasterStatus(e, 'fulfillmentCompleted')}
                                                        />
                                                        <div className="number"
                                                            onClick={(e) => this.handleEditItemMasterStatus(e, 'fulfillmentCompleted')}>{Summary.CompletedProcess ? Summary.CompletedProcess : 0}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="content-inhouse">
                                                <div className="content-head">
                                                    <span>In-House</span>
                                                </div>
                                                <div className="content-bottom">
                                                    <div className="content-bottom-left">
                                                        <Badge count="To Print"
                                                            style={{ backgroundColor: '#ffc000', color: 'black' }}
                                                            onClick={(e) => this.handleEditItemMasterStatus(e, 'readyToPrint')} />
                                                        <div className="number"
                                                            onClick={(e) => this.handleEditItemMasterStatus(e, 'readyToPrint')}>{Summary.ReadyToPrint ? Summary.ReadyToPrint : 0}</div>
                                                    </div>
                                                    <div className="content-bottom-right">
                                                        <Badge count="To Transmit"
                                                            style={{ backgroundColor: '#00b0f0' }}
                                                            onClick={(e) => this.handleEditItemMasterStatus(e, 'readyToTransmit')}
                                                        />
                                                        <div className="number"
                                                            onClick={(e) => this.handleEditItemMasterStatus(e, 'readyToTransmit')}>{Summary.ReadyToShip ? Summary.ReadyToShip : 0}</div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Menu.Item>
                                :
                                <Menu.Item key="header-status" className="cates item icon-header header-status">
                                    <div className="header-your-orders">
                                        <ul>
                                            <li className="first">
                                                <img src={button} height="10px" width="40px" />
                                                <h6>Summary</h6>
                                            </li>
                                            <li className="">
                                                <div className="result">
                                                    <h3 onClick={(e) => this.handleEditItemMasterStatus(e, 'awaitingFinalization')}
                                                    >{this.props.awaitingFinalizationTotal ? this.props.awaitingFinalizationTotal : 0}</h3>
                                                    <Badge count="Errors"
                                                        style={{ backgroundColor: '#c55a11' }}
                                                        onClick={(e) => this.handleEditItemMasterStatus(e, 'awaitingFinalization')} />
                                                </div>
                                            </li>
                                            <li className="printed">
                                                <div className="result">
                                                    <h3 onClick={(e) => this.handleEditItemMasterStatus(e, 'readyToPrint')}
                                                    >{Summary.ReadyToPrint ? Summary.ReadyToPrint : 0}</h3>
                                                    <Badge count="To Print"
                                                        style={{ backgroundColor: '#ffc000', color: 'black' }}
                                                        onClick={(e) => this.handleEditItemMasterStatus(e, 'readyToPrint')} />
                                                </div>
                                            </li>
                                            <li className="ship">
                                                <div className="result">
                                                    <h3 onClick={(e) => this.handleEditItemMasterStatus(e, 'readyToTransmit')}
                                                    >{Summary.ReadyToShip ? Summary.ReadyToShip : 0}</h3>
                                                    <Badge count="To Transmit"
                                                        style={{ backgroundColor: '#00b0f0' }}
                                                        onClick={(e) => this.handleEditItemMasterStatus(e, 'readyToTransmit')} />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </Menu.Item>
                        }
                    </Menu>
                    <Menu
                        className="header-right"
                        onClick={this.handleClick}
                        selectedKeys={[this.state.current]}
                        mode="horizontal"
                    >
                        {/* <Menu.Item key="search" className="item icon-header search" >
                            <SearchInput
                                placeholder="Channel Order #, Tracking #"
                                style={{ width: 260 }} location={history}
                            />
                        </Menu.Item> */}

                        <Dropdown
                            overlay={menu_manual}
                            trigger={['click']}
                            className='dropdow-operation-manual'
                            onClick={() => this.onClick()}
                        >
                            <a className="ant-dropdown-link">
                                <img src={operationManual} />
                            </a>
                        </Dropdown>

                        <Dropdown
                            overlay={menu}
                            trigger={['click']}
                            className='header-user-infor'
                            onClick={() => this.onClick()}
                        >
                            <a className="ant-dropdown-link">
                                <Tooltip
                                    placement="bottom"
                                    title={textTooltipUser}
                                    overlayClassName='header-user-infor-tooltip'
                                >
                                    <Avatar size="large" icon="user" />
                                    {user && user.first_name && typeof user.first_name === 'string' ? user.first_name.trim() : null}
                                </Tooltip>
                            </a>
                        </Dropdown>
                    </Menu>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        data: state.quickSearchReducer.data,
        search: state.quickSearchReducer.search,
        Summary: state.headerReducer.Summary,
        getOrderParams: {
            PageSize: state.ordersReducer.offset,
        },
        getShipmentParams: {
            PageSize: state.shipmentReducer.offset,
        },
        awaitingFinalizationTotal: state.ordersReducer.AwaitingFinalizationTotal,
        readyToPrintCount: state.shipmentReducer.ReadyToPrintCount,
        readyToTransmitCount: state.shipmentReducer.ReadyToTransmitCount,
        totalFulfillmentInProcessHead: state.shipmentReducer.TotalFulfillmentInProcessHead,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onQuickSearch: payload => {
            dispatch(onQuickSearch(payload))
        },
        resetHeaderSumary: payload => {
            dispatch(resetHeaderSumary(payload))
        },
        resetSumaryOrder: payload => {
            dispatch(resetSumaryOrder(payload))
        },
        resetSumaryShipment: payload => {
            dispatch(resetSumaryShipment(payload))
        },
        onLoadHeader: payload => {
            dispatch(onLoadHeader(payload))
        },
        onLoadPrinter: payload => {
            dispatch(onLoadPrinter(payload))
        },
        getHeaderSummary: () => {
            dispatch(getHeaderSummary())
        },
        onTab: payload => {
            dispatch(onTab(payload))
        },
        onTabShipment: payload => {
            dispatch(onTabShipment(payload))
        },
        fromSummary: payload => {
            dispatch(fromSummary(payload))
        },
        setFulfillmentOption: (payload) => {
            dispatch(setFulfillmentOption(payload))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header)



// WEBPACK FOOTER //
// ./src/components/header/index.js